import { createSelector } from '@ngrx/store';
import { selectChartsState } from 'app/main/charts/charts.selectors';
import * as fromCube from 'app/main/cube/cube.selectors';
import { AnalyticsSelectors } from 'app/main/analytics/selectors';
import * as _ from 'lodash';

export const selectUIChartsRevenueByCategory = createSelector(
    selectChartsState,
    state => state.revenueByCategory
);

export const selectChartsRevenueByCategory = createSelector(
    fromCube.selectCubeForRevenueByCategory,
    AnalyticsSelectors.selectCcat, 
    (cube, ccat) => {
        const result = [];
        const timelines = _.groupBy(cube, c => c.timeline);
        _.forEach(timelines, t => {
            const categories = _.groupBy(t, e => e.customerCategory);
            const series = [];
            _.forEach(ccat, category => {
                series.push({
                    name: category.name,
                    value: _.sumBy(categories[category.name], 'flux')
                });
            });
            if (categories['Autres']) {
                series.push({
                    name: 'Autres',
                    value: _.sumBy(categories['Autres'], 'flux')
                });
            }
            result.push({
                name: t[0].timeline,
                series
            });
        });
        return _.orderBy(result, ['name'], ['asc']);
    }
);

export const selectChartsRevenueByCategoryDetail = createSelector(
    fromCube.selectCubeForRevenueByCategory,
    selectUIChartsRevenueByCategory,
    (cube, revenueByCategory) => {
        const result = [];
        if (revenueByCategory && revenueByCategory.customerCategory) {
            const selection = cube.filter(
                c => c.timeline === revenueByCategory.timeline
                && c.customerCategory === revenueByCategory.customerCategory
            );
            const customers = _.groupBy(selection, 'customerLabel');
            _.forEach(customers, p => {
                const name = p[0].customerLabel;
                result.push({
                    name,
                    value: _.sumBy(p, 'flux')
                });
            });
        }
        return _.take(_.orderBy(result, ['value', 'name'], ['desc', 'asc']), 12);
    }
);
